var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77902 3.61809C8.77902 5.40659 7.32911 6.85653 5.54057 6.85653C3.75204 6.85653 2.30212 5.40662 2.30212 3.61809C2.30212 1.82955 3.75204 0.379639 5.54057 0.379639C7.32911 0.379639 8.77902 1.82955 8.77902 3.61809Z",
    fill: "#141320"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2818 4.82057C15.2818 6.15588 14.1993 7.23837 12.864 7.23837C11.5287 7.23837 10.4462 6.15588 10.4462 4.82057C10.4462 3.48526 11.5287 2.40277 12.864 2.40277C14.1993 2.40277 15.2818 3.48526 15.2818 4.82057Z",
    fill: "#141320"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0886 11.6608V12.9844C11.0886 13.4048 10.7398 13.7445 10.3194 13.7445H0.760055C0.33966 13.7445 0 13.4048 0 12.9844V11.6608C0 9.62112 1.65409 7.96136 3.69369 7.96136H7.38738C8.2282 7.96136 9.00659 8.24409 9.62894 8.71773C10.512 9.39332 11.0885 10.4599 11.0885 11.6606L11.0886 11.6608Z",
    fill: "#141320"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 10.6953V11.9363C16.9999 12.1695 16.8218 12.3678 16.5942 12.3861H11.933V11.5545C11.933 10.2253 11.318 9.03935 10.3578 8.26647C10.6663 8.1398 11.0022 8.07187 11.3566 8.07187H14.3729C15.8232 8.07187 17 9.24497 17 10.6953L16.9999 10.6953Z",
    fill: "#141320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCustomers);
export default __webpack_public_path__ + "static/media/menu-customers.0f9a241c2231396e22816687ac2a23ae.svg";
export { ForwardRef as ReactComponent };